"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothOBSCell;
var _qrcode = require("qrcode.react");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
var _utils = require("../utils");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var pulse = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n  100% {\n    transform: scale(1);\n  }\n"])));
var spin = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  to { transform: rotate(360deg); }\n"])));

// Loading spinner shown while the camera initializes. Color is admin-configurable.
var Spinner = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 64px;\n  height: 64px;\n  margin: -32px 0 0 -32px;\n  border-radius: 50%;\n  border: 5px solid rgba(255, 255, 255, 0.25);\n  border-top-color: ", ";\n  animation: ", " 1s linear infinite;\n  z-index: 4;\n  pointer-events: none;\n"])), function (props) {
  return props.color || '#ffffff';
}, spin);

// Styled Components
var Container = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  box-sizing: border-box;\n"])));
var ActionButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  display: block;\n  border-radius: 120px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 20rem;\n  padding: 14px 10px;\n  font-size: calc(1.4rem * var(--text-scale, 1));\n  margin-top: 0.3rem;\n  text-transform: uppercase;\n  background: #FFFFFF; /* Transparent white */\n  border: none;\n  font-weight: bold;\n  box-shadow: none;\nfont-family: inherit;\n"])));
var ButtonGroup = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  z-index: 100;\n"])), function (props) {
  return props.square ? '10%' : '2%';
});
var SecondaryButton = (0, _styledComponents.default)(ActionButton)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: calc(1rem * var(--text-scale, 1));\n  // margin-top: 1rem;\n  border-radius: 60px;\n\n  font-weight: bolf;\n  background: rgba(0,0,0,0.1);\n  border: solid 0.3em #FFFFFF;\n  box-shadow: none;\n\n  &:hover {\n  }\n"])));

/* "Changer le fond" — styled like the Figma "Continue" button: a green vertical gradient pill
   (#3AAA35 top → #008332 bottom) with a thick white outline, a glossy sheen on the upper half, and
   bold white uppercase text. */
var ChangeBgButton = (0, _styledComponents.default)(ActionButton)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 16px 24px;\n  font-size: calc(1.2rem * var(--text-scale, 1));\n  border-radius: 999px;\n  font-weight: bold;\n  color: #FFFFFF;\n  border: solid 0.28em #FFFFFF;\n  /* base green gradient + a top gloss overlay (lighter \u2192 transparent) for the glossy highlight */\n  background:\n    linear-gradient(180deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 55%),\n    linear-gradient(180deg, #3AAA35 0%, #008332 100%);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.25);\n  text-shadow: 0 1px 2px rgba(0,0,0,0.25);\n"])));
var Preview = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 2em;\n  overflow: hidden;\n  border: none;\n  margin: '0 auto';\n  border-radius: '36px';\n"])));
var PreviewWrapper = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\nposition: absolute;\nbottom: 3%;\npadding: 1em;\nwidth: 70%;\nmargin-left: -1em;\nleft: 15%;\nheight: 70%;\n// background: white;\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: space-between;\n/* Enforce portrait aspect ratio */\n/* margin: 20px auto; Removed margin as fixed positioning handles placement */\n// box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);\nz-index: 100; /* Ensure it's above other content */\n"])));
var ImageContainer = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100% - 60px);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius : 16px;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    // object-fit: contain; /* Preserve aspect ratio and fit inside the frame */\n    overflow: hidden;\n  }\n"])));
var ShareOptionsContainer = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  /* stretch (not flex-start) is what makes the three cards share one height. */\n  align-items: stretch;\n  /* Uniform gap instead of per-card margin-right, so the row stays symmetric. */\n  gap: 2.5%;\n  /* No px cap: on a 4K portrait booth a 1080px max-width left this block occupying about a\n     third of the screen. Percentage width scales with the display instead. */\n  width: 92%;\n  max-width: none;\n  z-index: 10;\n  padding: 0 1rem;\n  box-sizing: border-box;\n"])), function (props) {
  return props.square ? '18%' : '10%';
});
var ShareOptionCard = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  border-radius: 20px;\n  backdrop-filter: blur(100px);\n  -webkit-backdrop-filter: blur(100px);\n  /* flex: 1 1 0 (not 1 1 auto) \u2014 equal widths regardless of content, so the email card no longer\n     ends up wider than the other two just because it holds more. */\n  flex: 1 1 0;\n  min-width: 0;\n  /* clamp keeps the old 235px as the floor on small screens and scales up with viewport height. */\n  min-height: clamp(235px, 22vh, 420px);\n  position: relative;\n  box-sizing: border-box;\n"])));

/* Widths and margins now come from the container's flex + gap — these only carry their colours. */
var EmailCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n"])));
var QRCodeCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n"])));
var PrintCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n"])));
var CardTitle = _styledComponents.default.h3(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(clamp(18px, 1.6vh, 34px) * var(--text-scale, 1));\n  font-weight: 700;\n  text-align: center;\n  margin: 10px 0 0 0;\n  padding: 0 8px;\n  color: ", ";\n  line-height: 1.2;\n  height: clamp(60px, 5.5vh, 96px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.color || '#7A6742';
});
var EmailInput = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  /* % of the card, so it tracks the card's flex width instead of a fixed 240px. */\n  width: 88%;\n  height: clamp(36px, 3.4vh, 64px);\n  min-height: clamp(36px, 3.4vh, 64px);\n  flex-shrink: 0;\n  padding: 0;\n  border-radius: 100px;\n  background: rgba(255, 255, 255, 0.7);\n  font-family: inherit;\n  font-size: calc(clamp(15px, 1.4vh, 28px) * var(--text-scale, 1));\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  color: rgba(122, 103, 66, 0.5);\n  cursor: pointer;\n  margin: 12px 0 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])));
var SendButton = _styledComponents.default.button(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: clamp(120px, 11vh, 200px);\n  height: clamp(36px, 3.4vh, 64px);\n  padding: 0;\n  border-radius: 100px;\n  color: #FFFFFF;\n  font-family: inherit;\n  font-size: calc(clamp(18px, 1.6vh, 30px) * var(--text-scale, 1));\n  font-weight: 700;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  box-sizing: border-box;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n"])));
var QRCodeDisplay = _styledComponents.default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(120px, 11vh, 260px);\n  height: clamp(120px, 11vh, 260px);\n  margin: 0px auto 35px auto;\n"])));
var PrintIconContainer = _styledComponents.default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(100px, 9vh, 190px);\n  height: clamp(100px, 9vh, 190px);\n  margin: 32px auto 0 auto;\n"])));
var PrintButton = _styledComponents.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: clamp(78px, 7vh, 130px);\n  padding: 0;\n  text-align: center;\n  font-family: inherit;\n  font-size: calc(clamp(23px, 2vh, 40px) * var(--text-scale, 1));\n  font-weight: 700;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-top: 1.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    opacity: 0.6;\n    cursor: not-allowed;\n  ";
});
var ShareFormContainer = _styledComponents.default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  z-index: 10;\n  border-radius: 24px;\n  background:rgb(255, 255, 255, 0.2);\n  opacity: 0.4;\n  backdrop-filter: blur(20px);\n"])));
var ShareContent = _styledComponents.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 10rem;\n  gap: 0.5rem;\n  align-items: start;\n"])));
var FormTitle = _styledComponents.default.h2(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(0.9rem * var(--text-scale, 1));\n  font-weight: 500;\n  margin: 1rem 0;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  font-family: inherit;\n  color : #fff;\n"])));
var QRCodeWrapper = _styledComponents.default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  margin-left: 3rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 0.8rem;\n  width: 5rem;\n"])));
var PreviewWrapper2 = _styledComponents.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  bottom: ", ";\n  transform: translateX(-50%);\n  width: 73%;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 100;\n"])), function (props) {
  return props.square ? '12%' : '0%';
});
var ShareInput = _styledComponents.default.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  padding: 0.7rem 1rem;\n  border-radius: 2rem;\n  font-size: calc(1rem * var(--text-scale, 1));\n  font-family: inherit;\n  outline: none;\n  border: none;\n  background: #FFFFFF;\n  border: 0.1rem solid #000000;\n  &:focus {\n  }\n"])));
var ShareCheckbox = _styledComponents.default.label(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(0.8rem * var(--text-scale, 1));\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  line-height: 1.4;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n\n  }\n  input[type=\"checkbox\"]:checked {\n  background-color: #333;\n}\n"])));
var BackgroundWrapper = _styledComponents.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  background-size: cover;\n  background: rgba(0,0,0,0);\n  background-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var ShareButton = (0, _styledComponents.default)(ActionButton)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 40%;\n  border-radius: 2rem;\n  font-size: calc(1rem * var(--text-scale, 1));\n  padding: 0.5rem;\n  text-transform: none;\n  background: #FFFFFF;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12.5px);\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])));
var LogoImage = _styledComponents.default.img(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 30%;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
var LogoImage2 = _styledComponents.default.img(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 90%;\n  margin-top: 0.7rem;\n"])));
var ShareForm = _styledComponents.default.form(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var CameraContainer = _styledComponents.default.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n\n  position: relative;\n  border-radius: 0px;\n  overflow: hidden;\n\n  box-sizing: border-box;\n  background: ", "; /* Loading backdrop: admin-configurable, transparent by default */\n  /* Both formats center their inner box so the live feed has borders around it\n     (square = 1:1; portrait = the 15x10 box sized in Camera). */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.cameraReady ? 'transparent' : props.loaderBg || 'transparent';
});
var Camera = _styledComponents.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  position: relative;\n  /* Square mode: a centered 1:1 box. Width-driven (matches the share-preview box) so the\n     square side derives from width on a portrait kiosk; max-height guards a landscape cell.\n     Width < 100% leaves horizontal padding so the preview doesn't touch the screen edges.\n     Centered by CameraContainer's flexbox. */\n  ", "\n"])), function (props) {
  return props.square ? "\n    width: 90%;\n    height: auto;\n    aspect-ratio: 1 / 1;\n    max-height: 100%;\n    overflow: hidden;\n  " : "\n    /* Portrait (15x10) mode: a centered 2:3 box slightly inset from the screen so there are\n       borders around the live feed. Height-driven (kiosk is taller than the 2:3 photo) with a\n       width guard; both < 100% leave the surrounding margin. Centered by CameraContainer. */\n    width: auto;\n    height: 92%;\n    aspect-ratio: 2 / 3;\n    max-width: 92%;\n    overflow: hidden;\n  ";
});
var VideoPreview = _styledComponents.default.video(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  width: 110%;\n  height: 100%;\n  /* Center the 110%-wide element horizontally; tune this value on the booth if it drifts. */\n  margin-left: -2.5%;\n  object-fit: contain;\n  /* Rotate 90\xB0 and scale to match captured photo field of view (4:6 crop from rotated video) */\n  /* Square mode shows the centered 1:1 crop; scale(1.78) is a starting value \u2014 tune on the booth. */\n  transform: ", ";\n  transform-origin: center center;\n  border-radius: 2.2em;\n"])), function (props) {
  return props.square ? props.mirror ? 'scaleX(-1) rotate(90deg) scale(1.78)' : 'rotate(90deg) scale(1.78)' : props.mirror ? 'scaleX(-1) rotate(90deg) scale(1.57) translateY(-10px)' : 'rotate(90deg) scale(1.57)';
});

// Visible live preview. The canvas content is already cropped + rotated upright by the draw loop
// (same pipeline as the capture), so it needs NO CSS rotation — only the mirror, kept to match the
// previous selfie-style preview. object-fit: fill makes it cover the same box as the frame overlay
// (GifOverlay, also fill), so frame + photo line up exactly as they do in the final image.
var PreviewCanvas = _styledComponents.default.canvas(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  transform: ", ";\n  transform-origin: center center;\n  /* No border-radius: the canvas covers the full rectangle so the raw video behind never\n     peeks through rounded corners, and it matches the flat rectangular final image. */\n  z-index: 2;\n  pointer-events: none;\n"])), function (props) {
  return props.mirror ? 'scaleX(-1)' : 'none';
});

// COMMENTED OUT: Frozen frame feature (may be needed later)
// const FrozenFrame = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   /* Rotate 90° and scale to fill container (scale by container aspect ratio to compensate for rotation) */
//   transform: scaleX(-1) rotate(90deg) scale(1.57); // Mirror effect + 90° rotation like video
//   transform-origin: center center;
//   border-radius: 2.2em;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
// `;

// const ProcessingOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(2px);
//   z-index: 100;
//   border-radius: 2.2em;
// `;

// const ProcessingMessage = styled.div`
//   font-family: 'Helvetica Neue', sans-serif;
//   font-size: 1.5rem;
//   font-weight: 600;
//   color: white;
//   text-align: center;
//   padding: 1rem 2rem;
//   background: rgba(0, 0, 0, 0.6);
//   border-radius: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(10px);
// `;

var CountdownOverlay = _styledComponents.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 4rem;\n  height: 4rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.5);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownNumber = _styledComponents.default.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(1.8rem * var(--text-scale, 1));\n  font-weight: 700;\n  line-height: 1;\n"])));

// Progress bar container: Shows below camera loader when photo is being processed
var ProgressBarContainer = _styledComponents.default.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%; /* Positioned just below camera loader circle (at 50%) */\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60%;\n  max-width: 20rem;\n  z-index: 100; /* Higher than GifOverlay (z-index: 50) and CountdownOverlay (z-index: 3) */\n"])));
var ProgressBarWrapper = _styledComponents.default.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-top: 15px;\n  position: relative;\n"])));
var ProgressBarFill = _styledComponents.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", "%;\n  background: #fff;\n  background-size: 1rem 1rem;\n  animation: progressAnimation 0.5s linear infinite;\n  transition: width 0.3s ease-out;\n\n  @keyframes progressAnimation {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: 1rem 1rem;\n    }\n  }\n"])), function (props) {
  return props.progress;
});
var ProgressText = _styledComponents.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  text-align: center;\n  font-family: inherit;\n  font-size: calc(1rem * var(--text-scale, 1));\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n"])));
var GifOverlay = _styledComponents.default.img(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: 50;\n  pointer-events: none;\n"])));

// COMMENTED OUT: Flash animation feature (may be needed later)
// Flash overlay: Full-screen white flash animation that appears when photo is taken
// Shows for 500ms to simulate camera flash effect
// const FlashOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background-color: white;
//   z-index: 10000; // High z-index to cover everything
//   pointer-events: none; // Don't block user interactions
//   opacity: ${props => props.show ? 1 : 0};
//   transition: opacity 0.1s ease-out; // Smooth fade transition
// `;

var ControlBar = _styledComponents.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* center items horizontally */\n  justify-content: center;\n  position: absolute;\n  bottom: 65%; /* \"Prendre la photo\" \u2014 kept in its original position */\n  z-index: 60;\n  width: 100%;\n"])));

/* "Change background" bar. Rendered through a portal to <body> (see render), so it escapes
   every ancestor overflow-clip and CSS transform (the page's react-grid-layout wraps the cell
   in a transformed, offset box). position: fixed then resolves against the real viewport, so
   cell.change_bg_button_position is a straight % of screen height to the TOP of the button
   (0 = flush against the very top of the screen). */
var ChangeBgBar = _styledComponents.default.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  left: 0;\n  width: 100%;\n  z-index: 6000;\n"])));

/* Scene-picker carousel. Each tile is absolutely positioned in the track and placed purely by
   transform from its offset to the centred index — no layout work per frame, which matters because
   the live camera is decoding alongside this. Side tiles are scaled down, blurred and dimmed so the
   centre one reads as the current choice; the CSS filter blur is GPU'd and only ±2 tiles render. */
/* Slides are full-width overlays on the track, so `translate` percentages resolve against the track
   width: one step of 30% leaves the neighbours mostly tucked behind the centre tile with just their
   outer edge showing, which is the stacked look the booth had before. TILE_WIDTH is what keeps that
   edge visible at all — a centre tile spanning the whole track would hide the neighbours entirely. */
var SLOT = 30;
var TILE_WIDTH = 74;
var SIDE_SCALE = 0.72;
var SceneSlide = _styledComponents.default.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  /* The slide is only the SLOT the tile is centred in \u2014 it has definite width and height so the\n     tile's max-width/max-height percentages resolve. The tile itself shrinks to the image.\n     It must not catch clicks: the centre slide covers the whole track and would swallow taps meant\n     for the neighbours' visible edges. The tiles take the clicks instead. */\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate3d(", "%, 0, 0)\n             scale(", ");\n  filter: ", ";\n  opacity: ", ";\n  z-index: ", ";\n  transition: transform 0.35s cubic-bezier(0.25, 0.9, 0.3, 1), filter 0.35s ease, opacity 0.35s ease;\n  will-change: transform;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n"])), function (p) {
  return p.$offset * SLOT;
}, function (p) {
  return p.$offset === 0 ? 1 : SIDE_SCALE;
}, function (p) {
  return p.$offset === 0 ? 'none' : 'blur(5px)';
}, function (p) {
  return p.$offset === 0 ? 1 : 0.55;
}, function (p) {
  return 10 - Math.abs(p.$offset);
});

/* Slow breathe on the centred tile only — draws the eye to the choice without the whole row
   pulsing. Lives on the inner tile so it never fights the slide's carousel transform. */
var tileBounce = (0, _styledComponents.keyframes)(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  0%, 70%, 100% { transform: translate3d(0, 0, 0) scale(1); }\n  85%           { transform: translate3d(0, -10px, 0) scale(1.02); }\n"])));

/* The tile IS the thumbnail: max-width/max-height cap it to the slide, width/height stay auto, so
   the browser keeps the image's natural ratio and the bordered box hugs it exactly — no letterboxing
   and no cropping, whatever shape the booth's backgrounds are. */
var SceneTile = _styledComponents.default.img(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  display: block;\n  max-width: ", "%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  pointer-events: auto; /* re-enable on the tile \u2014 the slide around it is click-through */\n  cursor: pointer;\n  border-radius: 16px;\n  border: 3px solid rgba(255, 255, 255, ", ");\n  background: rgba(0, 0, 0, 0.15);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);\n  box-sizing: border-box;\n  animation: ", " 3.5s ease-in-out infinite;\n\n  &:active {\n    transform: scale(0.96);\n  }\n\n  /* Respect the OS setting \u2014 booths are public and some users are motion-sensitive. */\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"])), TILE_WIDTH, function (p) {
  return p.$center ? 0.95 : 0.5;
}, function (p) {
  return p.$center ? tileBounce : 'none';
});
var CameraButton = _styledComponents.default.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    cursor: pointer;\n\n"])));
var ButtonText = _styledComponents.default.div(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(1.2em * var(--text-scale, 1));\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: 1rem;\n  animation: ", " 1.2s ease-in-out infinite;\n"])), pulse);

// Measure a box's pixel height and keep it current across resizes. Used to size the user-info
// overlay text relative to the box height — the same basis the baked canvas uses (fraction of h).
// Returns [callbackRef, height]. A callback ref (not a plain ref) is required because the measured
// boxes (live Camera / share #preview-wrapper) are rendered conditionally on later steps: a plain
// ref + effect would run once at mount when the node doesn't exist yet and never re-measure. The
// callback ref fires the moment the node attaches, so we measure and observe it then.
var useBoxHeight = function useBoxHeight() {
  var _ref4 = (0, _react.useState)(0),
    _ref5 = _slicedToArray(_ref4, 2),
    h = _ref5[0],
    setH = _ref5[1];
  var roRef = (0, _react.useRef)(null);
  var setRef = _react.default.useCallback(function (el) {
    if (roRef.current) {
      roRef.current.disconnect();
      roRef.current = null;
    }
    if (!el) return;
    setH(el.clientHeight);
    var ro = new ResizeObserver(function () {
      return setH(el.clientHeight);
    });
    ro.observe(el);
    roRef.current = ro;
  }, []);
  return [setRef, h];
};

// User-info text (first name + bold SURNAME + birthdate) rendered as a DOM overlay over the live
// preview AND the share preview. Reproduces the baked drawUserInfo exactly so what the user sees
// matches the downloaded/printed image:
//   - font size = fraction of the box HEIGHT (0.042 name / 0.031 date), same constants as the canvas
//   - the NAME's vertical center is anchored at posPct from the bottom (canvas uses textBaseline:'middle')
//   - the date sits below the name by nameFont*0.95 (canvas: dateY = nameY + nameSize*0.95)
//   - horizontal center at hPosPct (canvas: centerX = w*hPosPct)
// boxH is measured by the caller (useBoxHeight) so this component stays pure and live/share can't drift.
var UserInfoOverlay = function UserInfoOverlay(_ref6) {
  var boxH = _ref6.boxH,
    sizeScale = _ref6.sizeScale,
    posPct = _ref6.posPct,
    hPosPct = _ref6.hPosPct,
    color = _ref6.color,
    font = _ref6.font,
    firstName = _ref6.firstName,
    surname = _ref6.surname,
    birthdate = _ref6.birthdate;
  if (!boxH) return null; // avoid a flash of 0px text before the ResizeObserver fires
  var nameFont = 0.042 * sizeScale * boxH; // == canvas nameSize
  var dateFont = 0.031 * sizeScale * boxH; // == canvas dateSize
  var first = (firstName || '').trim();
  var last = (surname || '').trim().toUpperCase();
  var date = (birthdate || '').trim();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      left: "".concat(hPosPct * 100, "%"),
      bottom: "".concat(posPct * 100, "%"),
      transform: 'translate(-50%, 50%)',
      // center on the bottom:posPct line == textBaseline:'middle'
      whiteSpace: 'nowrap',
      textAlign: 'center',
      pointerEvents: 'none',
      zIndex: 10,
      color: color || '#fff',
      fontFamily: font || 'Arial',
      lineHeight: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: "".concat(nameFont, "px"),
      position: 'relative'
    }
  }, first, first && last ? ' ' : '', /*#__PURE__*/_react.default.createElement("strong", {
    style: {
      fontWeight: 900
    }
  }, last), date && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: "translate(-50%, calc(-50% + ".concat(nameFont * 0.95, "px))"),
      // == canvas dateY = nameY + nameSize*0.95
      fontSize: "".concat(dateFont, "px"),
      lineHeight: 1,
      whiteSpace: 'nowrap'
    }
  }, date)));
};
function PhotoboothOBSCell(_ref7) {
  var cell = _ref7.cell,
    pageId = _ref7.pageId,
    screenType = _ref7.screenType,
    _ref7$uriTransformer = _ref7.uriTransformer,
    uriTransformer = _ref7$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref7$uriTransformer,
    project = _ref7.project,
    intl = _ref7.intl,
    defaultLanguage = _ref7.defaultLanguage;
  var _ref8 = (0, _react.useState)(''),
    _ref9 = _slicedToArray(_ref8, 2),
    email = _ref9[0],
    setEmail = _ref9[1];
  var _ref0 = (0, _react.useState)({}),
    _ref1 = _slicedToArray(_ref0, 2),
    textDatas = _ref1[0],
    setTextDatas = _ref1[1];
  var _ref10 = (0, _react.useState)(false),
    _ref11 = _slicedToArray(_ref10, 2),
    consent = _ref11[0],
    setConsent = _ref11[1];
  var _ref12 = (0, _react.useState)(true),
    _ref13 = _slicedToArray(_ref12, 2),
    terms = _ref13[0],
    setTerms = _ref13[1];
  var _ref14 = (0, _react.useState)(''),
    _ref15 = _slicedToArray(_ref14, 2),
    link = _ref15[0],
    setLink = _ref15[1];
  var _ref16 = (0, _react.useState)(false),
    _ref17 = _slicedToArray(_ref16, 2),
    isSending = _ref17[0],
    setIsSending = _ref17[1];
  var _ref18 = (0, _react.useState)(null),
    _ref19 = _slicedToArray(_ref18, 2),
    sendStatus = _ref19[0],
    setSendStatus = _ref19[1];
  // The step that follows scene selection (skip scene picker straight to this when <2 scenes).
  var stepAfterScene = cell.collect_user_info ? 'info' : 'camera';
  // Start on the scene picker; the fetch effect below collapses straight past it if there are <2 scenes.
  var _ref20 = (0, _react.useState)('scene'),
    _ref21 = _slicedToArray(_ref20, 2),
    step = _ref21[0],
    setStep = _ref21[1];
  // Selectable OBS backgrounds fetched from the backend (GET /obs/scenes). Empty until loaded.
  var _ref22 = (0, _react.useState)([]),
    _ref23 = _slicedToArray(_ref22, 2),
    scenes = _ref23[0],
    setScenes = _ref23[1];
  // Carousel: index of the centred (big, sharp) scene tile on the picker.
  var _ref24 = (0, _react.useState)(0),
    _ref25 = _slicedToArray(_ref24, 2),
    sceneIndex = _ref25[0],
    setSceneIndex = _ref25[1];
  var swipeXRef = (0, _react.useRef)(null);
  var _ref26 = (0, _react.useState)(null),
    _ref27 = _slicedToArray(_ref26, 2),
    capturedImage = _ref27[0],
    setCapturedImage = _ref27[1];
  // Per-session end-user info (NOT persisted) — entered on the 'info' step, baked into the canvas.
  var _ref28 = (0, _react.useState)(''),
    _ref29 = _slicedToArray(_ref28, 2),
    userFirstName = _ref29[0],
    setUserFirstName = _ref29[1];
  var _ref30 = (0, _react.useState)(''),
    _ref31 = _slicedToArray(_ref30, 2),
    userSurname = _ref31[0],
    setUserSurname = _ref31[1];
  var _ref32 = (0, _react.useState)(''),
    _ref33 = _slicedToArray(_ref32, 2),
    userBirthdate = _ref33[0],
    setUserBirthdate = _ref33[1];
  var _ref34 = (0, _react.useState)(null),
    _ref35 = _slicedToArray(_ref34, 2),
    activeInfoField = _ref35[0],
    setActiveInfoField = _ref35[1]; // which field the on-screen keyboard edits
  // Birthdate setter that forces dd-mm-yyyy. AzertyKeyboard always passes a functional updater
  // (v => v + key / v => v.slice(0,-1)); we recompute the mask from whatever digits remain.
  var setBirthdateMasked = function setBirthdateMasked(updater) {
    return setUserBirthdate(function (prev) {
      var raw = typeof updater === 'function' ? updater(prev) : updater;
      var d = (String(raw).match(/\d/g) || []).join('').slice(0, 8);
      return d.slice(0, 2) + (d.length > 2 ? '-' + d.slice(2, 4) : '') + (d.length > 4 ? '-' + d.slice(4, 8) : '');
    });
  };
  // Initial value is a placeholder; the real start value (photoTimer + LEAD_IN) is set in
  // startCountdown before the 'countdown' step ever renders.
  var _ref36 = (0, _react.useState)(0),
    _ref37 = _slicedToArray(_ref36, 2),
    countdown = _ref37[0],
    setCountdown = _ref37[1];
  var streamRef = (0, _react.useRef)(null);
  var previewCanvasRef = (0, _react.useRef)(null);
  var animationFrameId = (0, _react.useRef)(null);
  // OBS composites the finished feed (bg removal + background + foreground frame) upstream, so this
  // cell does NO in-app segmentation or background replacement — it just displays/captures the feed.
  var displayCanvasRef = (0, _react.useRef)(null); // Visible preview canvas: runs the SAME crop+rotate as capture (upright, no CSS rotation)
  var previewLoopRef = (0, _react.useRef)(null); // rAF id for the visible-preview draw loop
  var _ref38 = (0, _react.useState)(false),
    _ref39 = _slicedToArray(_ref38, 2),
    hasCamera = _ref39[0],
    setHasCamera = _ref39[1];
  var _ref40 = (0, _react.useState)(null),
    _ref41 = _slicedToArray(_ref40, 2),
    cameraError = _ref41[0],
    setCameraError = _ref41[1];
  var videoRef = (0, _react.useRef)(null);
  var cameraContainerRef = (0, _react.useRef)(null);
  // Callback refs + measured heights for the boxes that hold the user-info overlay, so its text can
  // be sized off their pixel height (mirroring the canvas bake). Live = the Camera box; share =
  // the #preview-wrapper box. Both boxes mount conditionally on later steps, so callback refs are
  // required (see useBoxHeight) to measure them once they actually appear.
  var _useBoxHeight = useBoxHeight(),
    _useBoxHeight2 = _slicedToArray(_useBoxHeight, 2),
    cameraBoxRef = _useBoxHeight2[0],
    cameraBoxH = _useBoxHeight2[1];
  var _useBoxHeight3 = useBoxHeight(),
    _useBoxHeight4 = _slicedToArray(_useBoxHeight3, 2),
    sharePreviewRef = _useBoxHeight4[0],
    shareBoxH = _useBoxHeight4[1];
  var progressIntervalRef = (0, _react.useRef)(null); // Store progress interval reference
  var _ref42 = (0, _react.useState)(false),
    _ref43 = _slicedToArray(_ref42, 2),
    keyboardVisible = _ref43[0],
    setKeyboardVisible = _ref43[1];
  var _ref44 = (0, _react.useState)(false),
    _ref45 = _slicedToArray(_ref44, 2),
    isSended = _ref45[0],
    setIsSended = _ref45[1];
  var _ref46 = (0, _react.useState)(false),
    _ref47 = _slicedToArray(_ref46, 2),
    printed = _ref47[0],
    setPrinted = _ref47[1];
  var _ref48 = (0, _react.useState)(null),
    _ref49 = _slicedToArray(_ref48, 2),
    imageUrl = _ref49[0],
    setImageUrl = _ref49[1];
  var _ref50 = (0, _react.useState)(''),
    _ref51 = _slicedToArray(_ref50, 2),
    font = _ref51[0],
    setFont = _ref51[1];
  var _ref52 = (0, _react.useState)(false),
    _ref53 = _slicedToArray(_ref52, 2),
    isProcessing = _ref53[0],
    setIsProcessing = _ref53[1]; // Track when photo is being processed (camera loader visible)
  var _ref54 = (0, _react.useState)(0),
    _ref55 = _slicedToArray(_ref54, 2),
    processingProgress = _ref55[0],
    setProcessingProgress = _ref55[1]; // Track processing progress (0-100)
  var _ref56 = (0, _react.useState)(false),
    _ref57 = _slicedToArray(_ref56, 2),
    showImage = _ref57[0],
    setShowImage = _ref57[1];
  var _ref58 = (0, _react.useState)(false),
    _ref59 = _slicedToArray(_ref58, 2),
    showEmail = _ref59[0],
    setShowEmail = _ref59[1];
  var _ref60 = (0, _react.useState)(false),
    _ref61 = _slicedToArray(_ref60, 2),
    showQRCode = _ref61[0],
    setShowQRCode = _ref61[1];
  var _ref62 = (0, _react.useState)(false),
    _ref63 = _slicedToArray(_ref62, 2),
    showPrint = _ref63[0],
    setShowPrint = _ref63[1];
  var _ref64 = (0, _react.useState)(null),
    _ref65 = _slicedToArray(_ref64, 2),
    capturedPreview = _ref65[0],
    setCapturedPreview = _ref65[1];
  var _ref66 = (0, _react.useState)(null),
    _ref67 = _slicedToArray(_ref66, 2),
    shareImage = _ref67[0],
    setShareImage = _ref67[1];
  var emailCardRef = (0, _react.useRef)(null);
  var _ref68 = (0, _react.useState)(textDatas.print),
    _ref69 = _slicedToArray(_ref68, 2),
    printButtonText = _ref69[0],
    setPrintButtonText = _ref69[1];

  // QRCodeSVG takes a NUMERIC size prop, so CSS can't scale it with its container. Measure the
  // QRCodeDisplay box and pass the resolved px. Starts at the old fixed 120 so a failed measurement
  // degrades to today's size rather than rendering a 0px (invisible, unscannable) code.
  var qrBoxRef = (0, _react.useRef)(null);
  var _ref70 = (0, _react.useState)(120),
    _ref71 = _slicedToArray(_ref70, 2),
    qrSize = _ref71[0],
    setQrSize = _ref71[1];
  (0, _react.useLayoutEffect)(function () {
    var el = qrBoxRef.current;
    if (!el) return;
    var measure = function measure() {
      var px = Math.floor(Math.min(el.clientWidth, el.clientHeight));
      if (px > 0) setQrSize(px);
    };
    measure();
    // The box is clamp()-sized off viewport height, so it changes on resize/rotation.
    if (typeof ResizeObserver === 'undefined') return;
    var ro = new ResizeObserver(measure);
    ro.observe(el);
    return function () {
      return ro.disconnect();
    };
  }, [step, showQRCode]);

  // OBS control path. In the packaged Electron kiosk, the main process reaches the LOCAL OBS
  // (127.0.0.1) — the hosted backend (api.mytreeosk.com) cannot. So prefer window.electronAPI when its
  // OBS methods exist (feature-detect the METHOD, not just the object — older kiosks expose
  // electronAPI without these). Otherwise fall back to the backend HTTP route (browser/dev, HARIBO).
  var obsApi = typeof window !== 'undefined' && window.electronAPI && typeof window.electronAPI.obsGetScenes === 'function' && typeof window.electronAPI.obsChangeScene === 'function' ? window.electronAPI : null;

  // Filters defined in the admin (cell.obs_filters) win over the booth's own config.json / OBS_SCENES
  // list; empty falls back to it, so booths driven by config.json keep working. Rows with no thumbnail
  // are dropped — the tile only renders when preview_uri is set, so such a row would be an invisible
  // but still swipeable slot. The id is bg_<slot>, the same shape config.json already uses.
  var cellFilters = (Array.isArray(cell.obs_filters) ? cell.obs_filters : []).filter(function (f) {
    return f && f.image_uri;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).slice(0, 10)
  // remove_background: OBS cuts the person out only when this filter actually HAS a background to
  // put behind them, and the operator hasn't asked to keep the real one (removal quality varies with
  // the room). Without it, a filter with no uploaded background still showed whatever placeholder the
  // booth's bg_N source happened to point at.
  .map(function (f) {
    return {
      id: "bg_".concat(f.slot),
      name: f.name || "Filtre ".concat(f.slot),
      preview_uri: f.image_uri,
      remove_background: !!f.background_uri && !f.keep_background
    };
  });

  // Scene picker: fetch the selectable OBS backgrounds once. If there are fewer than 2 (nothing to
  // choose from), skip the picker and go straight to the next step. OBS keeps whatever background is
  // already enabled. Any failure also skips the picker so the booth still works.
  (0, _react.useEffect)(function () {
    // Push the admin-uploaded backgrounds/overlays into OBS's bg_N / frame_N image sources. Built from
    // cell.obs_filters, NOT cellFilters — the latter is mapped down to {id, name, preview_uri}, so slot
    // and the two uris are already gone. Fired BEFORE the cellFilters branch on purpose: a row with a
    // background but no picker thumbnail is dropped from cellFilters, and syncing it still matters.
    // Fire-and-forget: the picker must never wait on OBS.
    if (obsApi && typeof obsApi.obsSyncFilters === 'function') {
      var toSync = (Array.isArray(cell.obs_filters) ? cell.obs_filters : []).filter(function (f) {
        return f && f.slot && (f.background_uri || f.overlay_uri);
      }).map(function (f) {
        return {
          slot: f.slot,
          background_uri: f.background_uri,
          overlay_uri: f.overlay_uri
        };
      });
      if (toSync.length) {
        // Two ceilings, both self-correcting on the next mount: re-pointing the source that is
        // CURRENTLY enabled makes OBS reload it live (a brief flash in the feed), and with a single
        // filter this races handleSceneSelect below — two independent websocket sessions, so bg_1 can
        // be enabled a moment before its file is re-pointed. Nothing corrupts: one sets `enabled`, the
        // other `inputSettings.file`. Both happen on mount, before anyone is in front of the camera.
        Promise.resolve(obsApi.obsSyncFilters(toSync)).then(function (r) {
          return console.log('[photobooth] obs filter sync:', r);
        }).catch(function (e) {
          return console.warn('[photobooth] obs filter sync failed:', e);
        });
      }
    }
    if (cellFilters.length) {
      setScenes(cellFilters);
      // A single filter leaves nothing to pick, but it still has to be APPLIED: the booth's own
      // config.json list is already enabled in OBS, an admin-defined one is not. handleSceneSelect
      // also advances the step, so the picker is skipped either way.
      if (cellFilters.length === 1) handleSceneSelect(cellFilters[0].id);
      return undefined;
    }
    var active = true;
    var load = obsApi ? obsApi.obsGetScenes() : fetch("".concat(project.backEndUri, "/obs/scenes")).then(function (r) {
      return r.ok ? r.json() : [];
    });
    Promise.resolve(load).then(function (list) {
      if (!active) return;
      var arr = Array.isArray(list) ? list : [];
      console.log('[photobooth] scenes loaded:', arr.map(function (s) {
        return {
          id: s.id,
          preview: s.preview_uri ? String(s.preview_uri).slice(0, 32) + '…' : null
        };
      }));
      setScenes(arr);
      if (arr.length < 2) setStep(stepAfterScene); // 0 or 1 scene => nothing to pick
    }).catch(function () {
      if (active) setStep(stepAfterScene);
    });
    return function () {
      active = false;
    };
  }, []);

  // Tell OBS to switch to the chosen background and advance IMMEDIATELY — do NOT await the OBS call.
  // OBS swaps the background live in the running Virtual Camera feed, so there's nothing to wait for;
  // awaiting it just added its latency to the tap. Fire-and-forget, log failures.
  var handleSceneSelect = function handleSceneSelect(sceneId) {
    var t0 = performance.now();
    // Scenes from config.json / the backend carry no remove_background field: undefined tells the kiosk
    // to leave the OBS filter exactly as it is, which is what those booths did before this existed.
    // cellFilters, not `scenes`: with a single filter this runs from the mount effect, before setScenes.
    var chosen = cellFilters.find(function (s) {
      return s.id === sceneId;
    });
    console.log('[photobooth] scene tap:', sceneId, obsApi ? '(via electron IPC)' : '(via backend)', chosen ? "removal ".concat(chosen.remove_background ? 'on' : 'off') : '');
    var call = obsApi ? obsApi.obsChangeScene(sceneId, chosen ? {
      removeBackground: chosen.remove_background
    } : undefined) : fetch("".concat(project.backEndUri, "/obs/change-scene"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        filterId: sceneId
      })
    });
    Promise.resolve(call).then(function () {
      return console.log('[photobooth] change-scene done in', (performance.now() - t0).toFixed(0), 'ms');
    }).catch(function (e) {
      return console.warn('OBS change-scene failed after', (performance.now() - t0).toFixed(0), 'ms:', e);
    });
    setStep(stepAfterScene);
  };
  var gpios = [0, 4, 17, 22, 27];
  (0, _react.useEffect)(function () {
    if (step === 'share') {
      gpios.forEach(function (gpio) {
        console.log("treeosk-btn-" + gpio);
      });

      // reset visibility
      setShowImage(false);
      setShowEmail(false);
      setShowQRCode(false);
      setShowPrint(false);

      // Déclenchements séquentiels
      setTimeout(function () {
        return setShowImage(true);
      }, 0);
      setTimeout(function () {
        return setShowEmail(true);
      }, 500);
      setTimeout(function () {
        return setShowQRCode(true);
      }, 1000);
      setTimeout(function () {
        return setShowPrint(true);
      }, 1500);
    }
  }, [step]);

  // COMMENTED OUT: Flash and frozen frame states (may be needed later)
  // const [showFlash, setShowFlash] = useState(false); // Controls flash animation visibility
  // const [frozenFrame, setFrozenFrame] = useState(null); // Frozen frame image after photo capture

  // Photo format: 'square' produces a 15x15 (1:1) photo; anything else keeps the
  // default 10x15 (2:3) portrait. Square mode uses its own frame asset so the
  // overlay isn't stretched (falls back to the standard frame if none uploaded).
  var isSquare = cell.photo_format === 'square';
  // Admin-configurable mirror (selfie) effect. Applied as the single source of truth in
  // drawUprightFrame, so the visible preview and the captured/printed/shared file are flipped by
  // the identical code path and always match. Default off => true (un-mirrored) orientation.
  var mirror = !!cell.mirror_image;
  // Admin-configurable camera rotation (0/90/180/270°), applied ON TOP of the format's base
  // rotation (the camera is mounted sideways, so the default format already rotates +90°). Folded
  // into drawUprightFrame — the single source of truth — so the visible preview and the
  // captured/shared/printed file all rotate by the identical code path and always match. 0 => same
  // orientation as before this setting existed.
  var extraRotation = ((parseInt(cell.camera_rotation, 10) || 0) % 360 + 360) % 360;
  // Net rotation applied to the source = the format's base rotation (default 10x15 rotates +90°
  // because the camera is mounted sideways; square 15x15 does not rotate) plus the admin extra.
  // Computed once here so the crop region and drawUprightFrame share a single source of truth.
  var baseRotation = isSquare ? 0 : 90;
  var netRotation = (baseRotation + extraRotation) % 360;
  // At 90°/270° the source axes swap relative to the upright output (a sideways-mounted camera, the
  // booth default). At 0°/180° they don't (e.g. an already-upright OBS feed with camera_rotation set
  // to cancel the base 90°). The crop must extract a landscape strip when swapped, portrait when not.
  var axesSwapped = netRotation % 180 === 90;
  // Panini print (10x15 / portrait format only): print 4 copies of the same photo in a 2x2 grid on
  // one 6x4 sheet, to be cut by hand. Print-only — email/QR keep the single full photo.
  var paniniPrint = !!cell.panini_print;
  // Admin-configurable countdown. `photoTimer` is how many visible numbers show (default 3);
  // `countUp` flips the displayed digits to ascending (1,2,3) instead of descending (3,2,1).
  // LEAD_IN is the fixed "Look at the camera" arrows phase that precedes the numbers.
  var photoTimer = Math.max(1, parseInt(cell.photo_timer, 10) || 3);
  var countUp = cell.photo_timer_direction === 'asc';
  var LEAD_IN = 2; // fixed "Look at the camera" arrows intro, in seconds
  // OBS bakes the foreground frame into the feed, so this cell draws NO in-app frame overlay.
  var frame_overlay_uri = null;
  // Final output canvas dimensions for the active format.
  // Square: 2160² = the native 1:1 crop from a 4K (3840×2160) feed, so there is no upscaling
  // (~366 dpi at 15 cm, exceeds the 300 dpi print target). Portrait: 1440×2160 (2:3) clears
  // 300 dpi for a 10×15 cm print (which needs ≥1181×1772).
  var OUTPUT_WIDTH = isSquare ? 2160 : 1440;
  var OUTPUT_HEIGHT = isSquare ? 2160 : 2160;

  // 1. Camera constraints. The OBS Virtual Camera outputs whatever the OBS canvas is set to (Settings
  //    → Video); these `ideal` values just ask for that size (no `max`, which would clip a portrait
  //    feed). Request a 4K-class 2:3 portrait (2160×3240) so a 2160×3240 OBS canvas is delivered
  //    natively. Keep the aspect at 2:3 to match OUTPUT (1440:2160) — the crop then takes the
  //    "already-upright, aspect matches" branch and passes the FULL frame through with no re-crop,
  //    just sharper. A non-2:3 canvas would re-crop and change framing. Higher res only improves the
  //    supersampled downscale to the 1440×2160 print canvas; it does NOT affect the OBS-composited
  //    background (that lives entirely in OBS, behind the camera).
  var VIDEO_WIDTH = 2160;
  var VIDEO_HEIGHT = 3240; // portrait 2:3, 4K-class — must match the OBS canvas aspect (2:3)

  // 2. Capture (default format): crop to 6:4 (horizontal), then rotate to portrait (4:6).
  //    Square format crops a centered square instead (see getCropRegion).
  //    The portrait crop is expressed as RATIOS of the actual frame (not fixed pixels) so the
  //    framing is identical at any camera resolution — captured from the original 1200×800 of
  //    1920×1080. Square uses min(w,h) and needs no ratio.
  var PORTRAIT_CROP_W_RATIO = 1200 / 1920; // 0.625
  var PORTRAIT_CROP_H_RATIO = 800 / 1080; // ~0.7407

  // Center-crop region of a sourceW x sourceH frame for the active format.
  // Shared by both the live preview and the capture so the framing is identical by construction.
  //
  // The crop must match how the frame is rotated downstream (see netRotation/axesSwapped):
  //  - Square: a centered square, rotation-independent.
  //  - axesSwapped (booth default, sideways camera, net 90°/270°): the legacy 3:2 LANDSCAPE crop —
  //    after the +90° rotation it becomes the upright 2:3 portrait. Ratios tuned on the booth; kept
  //    byte-identical so physical booths are unaffected.
  //  - not swapped (e.g. an already-upright OBS feed with camera_rotation cancelling the base 90°,
  //    net 0°/180°): crop a centered region whose aspect already matches the 2:3 portrait output,
  //    so it fills the canvas with no warp and no extreme zoom.
  var getCropRegion = function getCropRegion(sourceW, sourceH) {
    var cropW, cropH;
    if (isSquare) {
      cropW = cropH = Math.min(sourceW, sourceH);
    } else if (axesSwapped) {
      cropW = Math.round(sourceW * PORTRAIT_CROP_W_RATIO);
      cropH = Math.round(sourceH * PORTRAIT_CROP_H_RATIO);
    } else {
      // Largest centered region of the source with the output's portrait aspect (OUTPUT_WIDTH:OUTPUT_HEIGHT).
      var targetAspect = OUTPUT_WIDTH / OUTPUT_HEIGHT; // < 1 (portrait)
      if (sourceW / sourceH > targetAspect) {
        // Source is wider than target: height-limited (e.g. 1920x1080 -> 720x1080).
        cropH = sourceH;
        cropW = Math.round(sourceH * targetAspect);
      } else {
        cropW = sourceW;
        cropH = Math.round(sourceW / targetAspect);
      }
    }
    var sWidth = Math.min(cropW, sourceW);
    var sHeight = Math.min(cropH, sourceH);
    var sx = Math.max(0, Math.floor((sourceW - sWidth) / 2));
    var sy = Math.max(0, Math.floor((sourceH - sHeight) / 2));
    return {
      sx: sx,
      sy: sy,
      sWidth: sWidth,
      sHeight: sHeight
    };
  };

  // Draw the cropped region cover-fit into a canvasW x canvasH canvas, optionally rotated +90°.
  // The default (portrait) format rotates because the camera is mounted sideways; the square
  // (15x15) format does NOT rotate (rotate90 = false). Factored out so the live preview and the
  // capture produce the same image (minus the frame overlay, which is drawn on top afterwards).
  var drawUprightFrame = function drawUprightFrame(ctx, canvasW, canvasH, source, sx, sy, sWidth, sHeight) {
    var rotate90 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
    var mirror = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
    ctx.clearRect(0, 0, canvasW, canvasH);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvasW, canvasH);
    ctx.save();
    ctx.translate(canvasW / 2, canvasH / 2);
    // Horizontal flip BEFORE the rotate: scale-then-rotate yields a clean horizontal mirror of the
    // final upright image. (Doing it after the rotate would flip vertically instead.) Contained in
    // this save/restore so the frame/GIF overlay drawn afterwards is never mirrored.
    if (mirror) ctx.scale(-1, 1);
    // Rotation + axis-swap come from component scope (netRotation/axesSwapped) so the crop region and
    // this draw stay in lockstep — the format's base rotation plus the admin extra. The `rotate90`
    // param is vestigial (always !isSquare, which netRotation already encodes); kept for signature
    // stability at the existing callsites.
    if (netRotation) ctx.rotate(netRotation * Math.PI / 180);
    // At 90°/270° (axesSwapped) the canvas axes swap relative to the source, so the cover-fit math
    // must compare against the inverted aspect and swap which canvas dimension each draw extent maps to.
    var videoAspect = sWidth / sHeight;
    var canvasAspect = axesSwapped ? canvasH / canvasW : canvasW / canvasH;
    var drawW, drawH;
    if (videoAspect > canvasAspect) {
      drawH = axesSwapped ? canvasW : canvasH;
      drawW = drawH * videoAspect;
    } else {
      drawW = axesSwapped ? canvasH : canvasW;
      drawH = drawW / videoAspect;
    }
    ctx.drawImage(source, sx, sy, sWidth, sHeight, -drawW / 2, -drawH / 2, drawW, drawH);
    ctx.restore();
  };
  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.visibilityState === 'visible' && (step === 'camera' || step === 'countdown')) {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(function (track) {
          return track.stop();
        });
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      setTimeout(function () {
        _initializeCamera();
      }, 300);
    }
  };

  // Keep the OBS Virtual Camera live across the scene picker too. Acquiring a 1440×2160 DirectShow
  // virtual camera takes several seconds, so tearing it down for the picker and re-acquiring on return
  // made "CHANGER LE FOND" feel slow. Init on 'scene' (feed is already live when the user picks) and
  // hold the stream through scene↔camera↔countdown; only release it when leaving for share/idle.
  (0, _react.useEffect)(function () {
    var cameraLiveSteps = ['scene', 'camera', 'countdown'];
    if ((step === 'camera' || step === 'scene') && !streamRef.current) {
      _initializeCamera();
    }
    if (step === 'camera' || step === 'scene') {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (!cameraLiveSteps.includes(step)) {
        if (animationFrameId.current) {
          cancelAnimationFrame(animationFrameId.current);
          animationFrameId.current = null;
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setHasCamera(false);
      }
    };
  }, [step]);

  // Pause video feed when processing (UI only - doesn't affect backend)
  (0, _react.useEffect)(function () {
    if (isProcessing && videoRef.current) {
      videoRef.current.pause();
    } else if (!isProcessing && videoRef.current && hasCamera && step === 'camera') {
      // Resume video if we're back to camera step and not processing
      videoRef.current.play().catch(function (e) {
        console.warn('Could not resume video:', e);
      });
    }
  }, [isProcessing, hasCamera, step]);

  // Automatically generate QR code when step becomes 'share' and image is captured
  (0, _react.useEffect)(function () {
    if (step === 'share' && capturedImage && !link && !isSending && cell.qr_code) {
      // Automatically trigger share to generate QR code/link
      handleShare();
    }
  }, [step, capturedImage, link, isSending, cell.qr_code]);

  // Text font for ALL cell text. A cell-level choice (cell.text_font, a font NAME uploaded in the
  // project settings and injected globally as @font-face) wins; otherwise fall back to the project
  // default button font. This single value flows to the root BackgroundWrapper (whose family every
  // styled component now inherits), UserInfoOverlay, the inline info spans, and drawUserInfo's canvas.
  (0, _react.useEffect)(function () {
    setFont(cell.text_font || project && project.default_button_font || '');
  }, [cell.text_font, project]);

  // (Segmentation + background-preload effects removed: OBS composites the feed upstream.)

  // Visible preview loop: draw the live feed into displayCanvasRef using the SAME center-crop +
  // rotate as the capture, so what the user sees matches the final image by construction (no more
  // eyeballed CSS scale factors). When background replacement is active and a composited scene is
  // ready, that scene is the source; otherwise the raw video. The canvas is already upright, so it
  // is displayed with no CSS rotation — only the existing mirror (preserved as-is).
  (0, _react.useEffect)(function () {
    if (step !== 'camera' && step !== 'countdown') return;
    if (!hasCamera) return;

    // Cap the preview's internal resolution so the per-frame draw stays cheap. Higher than
    // photobooth_gif2's 720 because THIS cell does no in-app segmentation (OBS composites upstream),
    // so it has the main-thread headroom — and on a 4K portrait booth screen a 720-tall preview canvas
    // was visibly upscaled/pixelated. 1440 matches the OUTPUT height for a crisp preview; the 30fps
    // throttle below keeps the per-frame cost bounded.
    var PREVIEW_MAX = 1440;
    var previewScale = PREVIEW_MAX / Math.max(OUTPUT_WIDTH, OUTPUT_HEIGHT);
    var cw = Math.round(OUTPUT_WIDTH * previewScale);
    var ch = Math.round(OUTPUT_HEIGHT * previewScale);
    // Throttle the preview draw to the source's ~30fps. The OBS Virtual Camera only updates at 30fps,
    // so redrawing on every ~60fps rAF is wasted work (each draw downscales a 1440×2160 frame — the
    // source of the [Violation] warnings). ~33ms between draws ≈ 30fps, halving the per-frame cost.
    var PREVIEW_INTERVAL_MS = 33;
    var lastDraw = 0;
    var active = true;
    var _loop = function loop() {
      if (!active) return;
      var now = performance.now();
      if (now - lastDraw >= PREVIEW_INTERVAL_MS) {
        lastDraw = now;
        var video = videoRef.current;
        var display = displayCanvasRef.current;
        if (video && display && video.readyState >= 2 && video.videoWidth && video.videoHeight) {
          var vw = video.videoWidth;
          var vh = video.videoHeight;
          if (display.width !== cw) display.width = cw;
          if (display.height !== ch) display.height = ch;
          var ctx = display.getContext('2d');
          // OBS already composited the feed, so the preview source is simply the raw video.
          var source = video;
          var _getCropRegion = getCropRegion(source.width || vw, source.height || vh),
            sx = _getCropRegion.sx,
            sy = _getCropRegion.sy,
            sWidth = _getCropRegion.sWidth,
            sHeight = _getCropRegion.sHeight;
          drawUprightFrame(ctx, cw, ch, source, sx, sy, sWidth, sHeight, !isSquare, mirror);
        }
      }
      previewLoopRef.current = requestAnimationFrame(_loop);
    };
    _loop();
    return function () {
      active = false;
      if (previewLoopRef.current) {
        cancelAnimationFrame(previewLoopRef.current);
        previewLoopRef.current = null;
      }
    };
  }, [step, hasCamera, isSquare, mirror, extraRotation]);

  // Helper: Find camera deviceId by label substring
  function getCameraDeviceIdByLabel(_x) {
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  } // Update initializeCamera to use the helper
  function _getCameraDeviceIdByLabel() {
    _getCameraDeviceIdByLabel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(labelSubstring) {
      var devices, cameras, match;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return navigator.mediaDevices.enumerateDevices();
          case 1:
            devices = _context.v;
            // Only available after user has granted camera access at least once
            cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            }); // Try to find a camera whose label includes the substring (case-insensitive)
            match = cameras.find(function (cam) {
              return cam.label && cam.label.toLowerCase().includes(labelSubstring.toLowerCase());
            });
            return _context.a(2, match ? match.deviceId : cameras[0] ? cameras[0].deviceId : null);
        }
      }, _callee);
    }));
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  }
  var _initializeCamera = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var labelSubstring, deviceId, constraints, stream, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (animationFrameId.current) {
              cancelAnimationFrame(animationFrameId.current);
              animationFrameId.current = null;
            }
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            _context2.p = 1;
            // Choose the relevant camera by label substring (e.g., "logitech" or your camera's name)
            labelSubstring = cell.cameralabel; // <-- Change this to match your camera label
            console.log({
              cell: cell
            });
            _context2.n = 2;
            return getCameraDeviceIdByLabel(labelSubstring);
          case 2:
            deviceId = _context2.v;
            constraints = {
              video: {
                // `ideal` only — NO `max`. The OBS Virtual Camera delivers its native canvas (e.g. 1440×2160);
                // a `max` height below the canvas would clip the portrait feed (the 1440×1080 bug). `ideal`
                // requests the native size without forbidding it.
                width: {
                  ideal: VIDEO_WIDTH
                },
                height: {
                  ideal: VIDEO_HEIGHT
                },
                // Request a smooth framerate explicitly: without this, a camera often picks its highest
                // RESOLUTION mode, which on many webcams runs at 15fps (or less) — the usual cause of a
                // "slow" live feed. `ideal:30, min:24` steers it to a 24–30fps mode.
                frameRate: {
                  ideal: 30,
                  min: 24
                },
                facingMode: 'user',
                deviceId: deviceId ? {
                  exact: deviceId
                } : undefined
              },
              audio: false
            };
            _context2.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 300);
            });
          case 3:
            _context2.n = 4;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 4:
            stream = _context2.v;
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = function () {
                // Diagnostic: the resolution AND framerate actually negotiated. If the feed looks slow,
                // check fps here first — a low fps (e.g. 15) means the camera chose a high-res/low-fps mode
                // and is the feed's true bottleneck, independent of any canvas/draw cost.
                var track = stream.getVideoTracks()[0];
                var settings = track ? track.getSettings() : {};
                console.log('[photobooth] camera negotiated:', videoRef.current.videoWidth + 'x' + videoRef.current.videoHeight, '@', settings.frameRate != null ? Math.round(settings.frameRate) + 'fps' : 'fps unknown');
                videoRef.current.play().then(function () {
                  setHasCamera(true);
                  setCameraError(null);
                }).catch(function (e) {
                  setCameraError(e.message);
                });
              };
              streamRef.current = stream;
            }
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            setCameraError(_t2.message);
            setHasCamera(false);
            if (step === 'camera' || step === 'countdown') {
              setTimeout(function () {
                _initializeCamera();
              }, 1000);
            }
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return function initializeCamera() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleTakePhoto = function handleTakePhoto() {
    if (step === 'camera' && hasCamera) {
      setStep('countdown');
      startCountdown();
    }
  };

  // COMMENTED OUT: Frozen frame capture function (may be needed later)
  // Capture frozen frame from video to show while processing
  // const captureFrozenFrame = () => {
  //   if (!videoRef.current) return null;
  //
  //   const video = videoRef.current;
  //   // Check if video is ready
  //   if (video.videoWidth === 0 || video.videoHeight === 0) {
  //     return null;
  //   }

  //   const canvas = document.createElement('canvas');
  //   // Rotate 90°: swap width and height
  //   canvas.width = video.videoHeight;
  //   canvas.height = video.videoWidth;
  //   const ctx = canvas.getContext('2d');
  //
  //   // Rotate 90° clockwise and apply mirror effect to match video display
  //   ctx.translate(canvas.width, 0);
  //   ctx.rotate(Math.PI / 2); // 90° clockwise
  //   ctx.scale(-1, 1); // Mirror effect
  //   ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  //
  //   return canvas.toDataURL('image/jpeg', 0.9);
  // };

  var startCountdown = function startCountdown() {
    setCountdown(photoTimer + LEAD_IN);
    var countdownInterval = setInterval(function () {
      setCountdown(function (prev) {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          // When countdown reaches 0, show camera loader and pause video feed (UI only)
          setIsProcessing(true);
          setProcessingProgress(0); // Reset progress
          // Pause video feed immediately when processing starts (UI only - doesn't affect backend)
          if (videoRef.current) {
            videoRef.current.pause();
          }

          // Start progress animation - increments from 0% to 90% gradually
          // Progress will jump to 100% when actual photo processing completes
          var progress = 0;
          progressIntervalRef.current = setInterval(function () {
            progress += 2; // Increment by 2% every ~200ms
            if (progress >= 90) {
              progress = 90; // Cap at 90% until actual processing completes
            }
            setProcessingProgress(progress);
          }, 200);

          // Capture photo (runs in background while video is paused in UI)
          capturePhoto();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Build a 2x2 tiled (panini) version of a captured photo data URL. The source already has the
  // frame baked in, so each of the 4 quadrants is a full framed copy. A 2x2 grid of a 2:3 image is
  // itself 2:3, so the result flows through the existing portrait print path unchanged.
  var buildPaniniImage = function buildPaniniImage(imageDataUrl) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var tileW = img.naturalWidth || OUTPUT_WIDTH;
        var tileH = img.naturalHeight || OUTPUT_HEIGHT;
        var canvas = document.createElement('canvas');
        canvas.width = tileW * 2;
        canvas.height = tileH * 2;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, tileW, tileH);
        ctx.drawImage(img, tileW, 0, tileW, tileH);
        ctx.drawImage(img, 0, tileH, tileW, tileH);
        ctx.drawImage(img, tileW, tileH, tileW, tileH);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = imageDataUrl;
    });
  };
  function printImageData(imageDataUrl) {
    var isPanini = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (printed) return;
    console.log('treeosk-print'); // diffuser marker: fires once per print tap (see rpi-service watcher)
    if (window.electronAPI) {
      // Pass the format so the Electron side selects the page layout:
      //  - square: 150×150mm page
      //  - panini: exact 152×102mm (6×4) page with NO calibration fudge, so the 2x2 cut seam lands
      //    on the true paper center (the default portrait path is centered on the printable area,
      //    which is offset from the physical paper center — invisible for one photo, not for a cut).
      //  - default: the existing calibrated portrait (A4 + fudge) layout.
      window.electronAPI.sendImageForPrint(imageDataUrl, {
        square: isSquare,
        panini: isPanini
      });
    }
    if (window.Android && typeof window.Android.postMessage === 'function') {
      window.Android.postMessage(imageDataUrl);
    }
    setPrinted(true);
  }
  var fallbackCapturePhoto = function fallbackCapturePhoto() {
    if (!videoRef.current || !previewCanvasRef.current) {
      console.error('❌ Video or canvas not available');
      return;
    }
    var canvas = previewCanvasRef.current;
    var context = canvas.getContext('2d');
    var video = videoRef.current;

    // Check if video is ready
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.error('❌ Video not ready');
      // COMMENTED OUT: Frozen frame state reset (may be needed later)
      // setIsProcessing(false);
      // setFrozenFrame(null);
      return;
    }
    // 1. Crop the source region from the 16:9 video.
    //    - default: center 6:4 region, then rotated to a 2:3 portrait
    //    - square : center square region (no distortion once cover-fit into the 1:1 canvas)
    // Shared with the live preview (getCropRegion) so framing matches exactly.
    var _getCropRegion2 = getCropRegion(video.videoWidth, video.videoHeight),
      sx = _getCropRegion2.sx,
      sy = _getCropRegion2.sy,
      sWidth = _getCropRegion2.sWidth,
      sHeight = _getCropRegion2.sHeight;
    var targetWidth = sWidth;
    var targetHeight = sHeight;

    // 2. Prepare canvas for the active output format (overwritten in processPhotoCapture).
    canvas.width = OUTPUT_WIDTH;
    canvas.height = OUTPUT_HEIGHT;

    // No frame uploaded -> capture the photo without any overlay.
    if (!frame_overlay_uri) {
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
      return;
    }
    var gifImg = new Image(targetWidth, targetHeight);
    gifImg.style.backgroundColor = 'white';
    gifImg.style.width = '100%';
    gifImg.style.height = '100%';
    gifImg.style.objectFit = 'cover';
    gifImg.style.objectPosition = 'center';
    gifImg.height = targetHeight;
    gifImg.width = targetWidth;
    gifImg.style.backgroundSize = 'cover';
    gifImg.crossOrigin = 'Anonymous';

    // Add timeout to prevent infinite waiting
    var timeoutId = setTimeout(function () {
      console.warn('⚠️ GIF image load timeout, proceeding without GIF overlay');
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, targetWidth, targetHeight, null);
    }, 10000); // 10 second timeout

    gifImg.onload = function () {
      clearTimeout(timeoutId);
      console.log(gifImg);
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg);
    };
    gifImg.onerror = function (error) {
      clearTimeout(timeoutId);
      console.error('❌ Error loading GIF overlay:', error);
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
    };
    gifImg.src = frame_overlay_uri;
  };

  // OBS composites the feed upstream, so there is no in-app scene build; capture uses the raw video.
  var buildSceneCanvas = function buildSceneCanvas() {
    return null;
  };

  // Draw the user-info bar (first name / surname + birthdate) onto a canvas, like the Panini card.
  // Called on the preview, share AND print canvases so on-screen, QR/email, and print all match.
  var drawUserInfo = function drawUserInfo(ctx, w, h) {
    if (!cell.collect_user_info) return;
    if (!userFirstName && !userSurname && !userBirthdate) return;
    // Admin-configurable: text size (scale multiplier) and vertical position (% from the bottom).
    var sizeScale = cell.user_info_text_size || 1;
    var posPct = (cell.user_info_text_position != null ? cell.user_info_text_position : 12) / 100;
    var hPosPct = (cell.user_info_text_h_position != null ? cell.user_info_text_h_position : 50) / 100;
    var nameSize = Math.round(h * 0.042 * sizeScale); // ≈ previous barH*0.3 at scale 1
    var dateSize = Math.round(h * 0.031 * sizeScale); // ≈ previous barH*0.22 at scale 1
    // Anchor the name line at `position` % above the bottom; the date sits just under it.
    var nameY = h - h * posPct;
    var centerX = w * hPosPct; // horizontal center: 0 = left, 0.5 = center, 1 = right
    var dateY = nameY + nameSize * 0.95;
    ctx.save();
    // No background bar — text is drawn directly over the photo. No shadow.
    ctx.fillStyle = cell.user_info_text_color || '#fff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var family = font || 'Arial';
    // Line 1: first name (regular) + surname (bold), centered together.
    var first = (userFirstName || '').trim();
    var last = (userSurname || '').trim().toUpperCase();
    var gap = first && last ? nameSize * 0.3 : 0;
    ctx.font = "".concat(nameSize, "px ").concat(family);
    var firstW = first ? ctx.measureText(first).width : 0;
    ctx.font = "900 ".concat(nameSize, "px ").concat(family);
    var lastW = last ? ctx.measureText(last).width : 0;
    var totalW = firstW + gap + lastW;
    var cursor = centerX - totalW / 2;
    ctx.textAlign = 'left';
    if (first) {
      ctx.font = "".concat(nameSize, "px ").concat(family);
      ctx.fillText(first, cursor, nameY);
      cursor += firstW + gap;
    }
    if (last) {
      ctx.font = "900 ".concat(nameSize, "px ").concat(family);
      ctx.fillText(last, cursor, nameY);
    }
    // Line 2: birthdate, centered, just under the name.
    if (userBirthdate) {
      ctx.textAlign = 'center';
      ctx.font = "".concat(dateSize, "px ").concat(family);
      ctx.fillText(userBirthdate.trim(), centerX, dateY);
    }
    ctx.restore();
  };

  // Helper function to process photo capture
  var processPhotoCapture = function processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg) {
    try {
      // When background replacement is active and ready, draw from the composited scene instead
      // of the raw video. The scene shares the video's dimensions, so all crop/rotation math below
      // stays identical and applies to every output (preview, share, print).
      var frameSource = buildSceneCanvas(video) || video;
      canvas.width = OUTPUT_WIDTH;
      canvas.height = OUTPUT_HEIGHT;

      // Diagnostic: what the camera actually delivered vs what we crop/output. If the short axis is
      // below the output size, the result is upscaled (softer) — check this if quality looks low.
      console.log('[photobooth] capture res — video:', video.videoWidth + 'x' + video.videoHeight, '| crop:', sWidth + 'x' + sHeight, '| output:', OUTPUT_WIDTH + 'x' + OUTPUT_HEIGHT);

      // --- Création de l'image pour la preview (affichée sur l'écran de partage) ---
      // Full output resolution so the on-screen preview is as crisp as the final image (one-time
      // toDataURL, no per-frame cost).
      var previewCanvas = document.createElement('canvas');
      previewCanvas.width = OUTPUT_WIDTH; // taille de preview
      previewCanvas.height = OUTPUT_HEIGHT;
      var previewCtx = previewCanvas.getContext('2d');

      // Dessiner la vidéo avec crop (rotation +90° sauf en format carré 15x15), comme le canvas final.
      drawUprightFrame(previewCtx, previewCanvas.width, previewCanvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);

      // NB: the user-info text is NOT baked into the preview canvas. On screen the animated filter
      // (live_frame_uri) is a DOM <img> layered on top of this preview image, so baked text would sit
      // behind it. Instead the info is rendered as a DOM element ABOVE the filter overlay (see render).
      // The print/share canvases DO bake it (drawn after the GIF), so the saved/printed image is correct.

      var previewData = previewCanvas.toDataURL('image/png');
      setCapturedPreview(previewData); // state pour preview

      // --- Canvas pour l'image à partager (GIF plein écran) ---
      var shareCanvas = document.createElement('canvas');
      shareCanvas.width = canvas.width; // même taille que l'impression
      shareCanvas.height = canvas.height;
      var shareCtx = shareCanvas.getContext('2d');

      // Dessiner la vidéo (rotation +90° sauf en format carré 15x15)
      drawUprightFrame(shareCtx, shareCanvas.width, shareCanvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);

      // Dessiner le GIF **plein écran**, sans scale ni offset
      if (gifImg) {
        shareCtx.drawImage(gifImg, 0, 0, shareCanvas.width, shareCanvas.height);
      }

      // Barre d'informations utilisateur (nom / prénom / date de naissance)
      drawUserInfo(shareCtx, shareCanvas.width, shareCanvas.height);

      // Stocker dans l'état
      var shareData = shareCanvas.toDataURL('image/png');
      setShareImage(shareData);

      // --- Canvas principal pour l'impression (rotation +90° sauf en format carré 15x15) ---
      drawUprightFrame(context, canvas.width, canvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);

      // --- Superposer GIF seulement pour l'impression ---
      if (gifImg) {
        // const scale = 0.986; 
        // const gifWidth = canvas.width * scale; 
        // const gifHeight = canvas.height * scale; 
        // const mmToPx = (mm) => Math.round(mm * 300 / 25.4); 
        // const offsetX = mmToPx(1); 
        // const offsetY = mmToPx(0.3)
        // const gifX = (canvas.width - gifWidth) / 2 + offsetX; 
        // const gifY = (canvas.height - gifHeight) / 2 + offsetY; 
        // context.drawImage(gifImg, gifX, gifY, gifWidth, gifHeight);
        // Grande imprimante
        context.drawImage(gifImg, 0, 0, canvas.width, canvas.height);
      }

      // Barre d'informations utilisateur (nom / prénom / date de naissance)
      drawUserInfo(context, canvas.width, canvas.height);
      var imageData = canvas.toDataURL('image/png');
      setCapturedImage(imageData); // state pour l'impression / partage

      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setProcessingProgress(100);
      setTimeout(function () {
        setIsProcessing(false);
        setProcessingProgress(0);
        setStep('share');
      }, 300);
    } catch (error) {
      console.error('❌ Error processing photo capture:', error);
      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setIsProcessing(false);
      setProcessingProgress(0);
    }
  };
  var capturePhoto = function capturePhoto() {
    fallbackCapturePhoto(); // Always use fallback to ensure GIF is drawn
    // console.log('treeosk-btn-' + cell.gpio_number);
  };
  var handleRetake = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            setCapturedImage(null);
            setLink(''); // Reset link so it can be regenerated for new photo
            setIsSended(false); // Reset email sent status
            setPrinted(false);
            setPrintButtonText(textDatas.print);
            // Clear progress interval if still running
            if (progressIntervalRef.current) {
              clearInterval(progressIntervalRef.current);
              progressIntervalRef.current = null;
            }
            setIsProcessing(false); // Reset processing state
            setProcessingProgress(0); // Reset progress

            // Clean up existing camera stream
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            setHasCamera(false);
            setStep('camera');
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleRetake() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
      var img, imageData, response, record, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (e) {
              e.preventDefault();
            }
            setSendStatus(null);
            _context4.p = 1;
            if (!(email && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(email))) {
              _context4.n = 2;
              break;
            }
            throw new Error('Invalid email address');
          case 2:
            if (shareImage) {
              _context4.n = 3;
              break;
            }
            throw new Error('No captured image available');
          case 3:
            // Set sending state only after we start the actual upload
            setIsSending(true);

            // Use the original high-resolution capturedImage (2160x3240px) for digital/QR code
            // Convert PNG to high-quality JPEG to reduce file size while maintaining quality
            img = new Image();
            img.crossOrigin = 'anonymous';
            _context4.n = 4;
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                // Create a canvas matching the loaded image natural size to avoid any squash/stretch
                var naturalW = img.naturalWidth || img.width;
                var naturalH = img.naturalHeight || img.height;
                var canvas = document.createElement('canvas');
                canvas.width = naturalW;
                canvas.height = naturalH;
                var ctx = canvas.getContext('2d');

                // Draw the image at its natural size
                ctx.drawImage(img, 0, 0, naturalW, naturalH);

                // Convert to high-quality JPEG (0.95 quality for good balance between size and quality)
                var jpegData = canvas.toDataURL('image/jpeg', 0.95);
                resolve(jpegData);
              };
              img.onerror = reject;
              img.src = shareImage;
            });
          case 4:
            imageData = _context4.v;
            setImageUrl(imageData);
            _context4.n = 5;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: imageData,
                // Utiliser l'image capturée
                email: email,
                consent: consent,
                terms: terms,
                // Le sujet/corps/expéditeur du mail sont résolus côté back à partir de cell_id : on
                // n'envoie que la langue courante pour qu'il choisisse la bonne traduction.
                language_code: intl && intl.locale,
                project_id: project.id
              })
            });
          case 5:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 6;
              break;
            }
            throw new Error('Upload failed');
          case 6:
            _context4.n = 7;
            return response.json();
          case 7:
            record = _context4.v;
            setSendStatus('success');
            setLink(record.image_uri);
            setEmail('');
            setConsent(false);
            if (email) {
              setIsSended(true);
            }

            // Only set isSending to false after link is set and QR code can render
            setIsSending(false);
            _context4.n = 9;
            break;
          case 8:
            _context4.p = 8;
            _t3 = _context4.v;
            setSendStatus('error: ' + _t3);
            setIsSending(false);
          case 9:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function handleShare(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  // Textes par défaut (repli). Les champs éditables de la cellule, quand ils sont renseignés,
  // priment via i18nData(cell, '<champ>_text', ...) aux points d'affichage (look/buttonTake/
  // buttonDownload/conditions). NB : `description` (description_text) et `conditions2`
  // (conditions2_text) ne sont affichés nulle part dans la mise en page actuelle de la cellule —
  // les renseigner dans l'admin n'a donc aucun effet tant qu'aucun point d'affichage n'est ajouté.
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setTextDatas({
          description: 'Recevez la photo par e-mail ou scannez le code QR.',
          buttonDownload: 'Telecharger la photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Touchez pour commencer',
          send: 'Envoyer',
          sendByEmail: 'Recevoir la photo par email',
          // <-- ajouté
          conditions: "J'accepte de recevoir ma photo par email",
          conditions2: "J'ai lu et j'accepte les conditions générales.",
          sent: 'Votre photo a bien été envoyée',
          look: 'Regardez la caméra',
          preparingPhoto: 'Photo en cours de préparation...',
          almostThere: 'On y est presque...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRIMER',
          print: 'IMPRESSION'
        });
        break;
      case 'nl':
        setTextDatas({
          description: 'Ontvang de foto per e-mail of scan de QR-code.',
          buttonDownload: 'Download de foto',
          buttonRetake: 'Hernoemen',
          buttonTake: 'Maak een foto',
          send: 'Verzenden',
          sendByEmail: 'Verzenden per e-mail',
          // <-- ajouté
          conditions: 'Ik ga akkoord met het ontvangen van de foto op mijn e-mailadres',
          conditions2: 'Ik heb de algemene voorwaarden gelezen en ga ermee akkoord.',
          sent: 'Foto verzonden!',
          look: 'Kijk naar de camera',
          preparingPhoto: 'Foto voorbereiden...',
          almostThere: 'Bijna klaar...',
          emailPlaceholder: 'EMAIL',
          printed: 'AFGEDRUKT',
          print: 'AFDRUKKEN'
        });
        break;
      case 'en':
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Touch to start',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
      case 'de':
        setTextDatas({
          description: 'Erhalten Sie das Foto per E-Mail oder scannen Sie den QR-Code.',
          buttonDownload: 'Foto herunterladen',
          buttonRetake: 'Foto erneut aufnehmen',
          buttonTake: 'Foto aufnehmen',
          send: 'Senden',
          sendByEmail: 'Per E-Mail senden',
          // <-- ajouté
          conditions: 'Ich stimme zu, das Foto an meine E-Mail-Adresse zu erhalten',
          conditions2: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie.',
          sent: 'Foto gesendet!',
          look: 'Schau in die Kamera',
          preparingPhoto: 'Foto wird vorbereitet...',
          almostThere: 'Fast fertig...',
          emailPlaceholder: 'EMAIL',
          printed: 'GEDRUCKT',
          print: 'DRUCKEN'
        });
        break;
      case 'es':
        setTextDatas({
          description: 'Recibe la foto por correo electrónico o escanea el código QR.',
          buttonDownload: 'Descargar foto',
          buttonRetake: 'Volver a tomar la foto',
          buttonTake: 'Tomar foto',
          send: 'Enviar',
          sendByEmail: 'Enviar por correo',
          // <-- ajouté
          conditions: 'Acepto recibir la foto en mi dirección de correo electrónico',
          conditions2: 'He leído y acepto los términos y condiciones.',
          sent: '¡Foto enviada!',
          look: 'Mira a la cámara',
          preparingPhoto: 'Preparando foto...',
          almostThere: 'Casi listo...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESO',
          print: 'IMPRIMIR'
        });
        break;
      default:
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Take Photo',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
    }
  }, [intl.locale, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BackgroundWrapper, {
    style: _objectSpread({
      color: cell.text_color,
      fontFamily: font,
      '--text-scale': cell.text_size || 1
    }, cell.letter_spacing ? {
      letterSpacing: "".concat(cell.letter_spacing, "px")
    } : {})
  }, /*#__PURE__*/_react.default.createElement(Container, null, step === 'scene' && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1.5rem',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.5rem',
      padding: '1.75rem',
      // Explicit height: the grid inside sizes from THIS box, so a shrink-wrapped panel
      // (height:auto) collapses the rows to zero and the tiles render as thin lines.
      width: '90%',
      height: '82%',
      boxSizing: 'border-box',
      background: 'rgba(0,0,0,0.38)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: '28px',
      border: '1px solid rgba(255,255,255,0.18)',
      boxShadow: '0 10px 40px rgba(0,0,0,0.35)'
    }
  }, textDatas.look_text && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 'calc(2rem * var(--text-scale, 1))',
      fontWeight: 'bold',
      textAlign: 'center',
      // Force white on the scrim: cell.text_color is picked to sit on the booth's own
      // background and can be dark, which would vanish here.
      color: '#FFFFFF',
      textShadow: '0 2px 8px rgba(0,0,0,0.5)'
    }
  }, textDatas.look_text), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative',
      width: '100%',
      flex: '1 1 auto',
      minHeight: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      touchAction: 'pan-y'
    },
    onTouchStart: function onTouchStart(e) {
      swipeXRef.current = e.touches[0].clientX;
    },
    onTouchEnd: function onTouchEnd(e) {
      var start = swipeXRef.current;
      swipeXRef.current = null;
      if (start == null) return;
      var dx = e.changedTouches[0].clientX - start;
      if (Math.abs(dx) < 40) return; // below this it's a tap, not a swipe
      setSceneIndex(function (n) {
        return Math.min(scenes.length - 1, Math.max(0, n + (dx < 0 ? 1 : -1)));
      });
    }
  }, scenes.map(function (s, i) {
    var offset = i - sceneIndex;
    if (Math.abs(offset) > 2) return null;
    return /*#__PURE__*/_react.default.createElement(SceneSlide, {
      key: s.id,
      $offset: offset
    }, s.preview_uri ? /*#__PURE__*/_react.default.createElement(SceneTile, {
      $center: offset === 0,
      onClick: function onClick() {
        return offset === 0 ? handleSceneSelect(s.id) : setSceneIndex(i);
      }
      /* The kiosk's own list sends a data: URI read from its local backgrounds/ folder
         — pass those through, uriTransformer would mangle the base64 into nonsense.
         Admin-uploaded thumbnails are S3 URLs that the offline bundle flattens to a
         basename, so everything else DOES go through uriTransformer. */,
      src: /^data:/.test(s.preview_uri) ? s.preview_uri : uriTransformer(s.preview_uri),
      alt: s.name,
      onError: function onError(e) {
        console.warn('[photobooth] thumbnail failed for', s.id, '-', String(s.preview_uri).slice(0, 60));
        e.target.style.display = 'none';
      }
    }) : null /* ponytail: no thumbnail => no tile. Swipe/dots still reach the scene. */);
  })), scenes.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      gap: '0.6rem',
      flex: '0 0 auto'
    }
  }, scenes.map(function (s, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: s.id,
      onClick: function onClick() {
        return setSceneIndex(i);
      },
      style: {
        width: '0.7rem',
        height: '0.7rem',
        borderRadius: '50%',
        cursor: 'pointer',
        background: i === sceneIndex ? '#FFFFFF' : 'rgba(255,255,255,0.35)',
        transition: 'background 0.25s ease'
      }
    });
  })))), step === 'info' && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      // Sit a bit below dead-center so the form isn't too high on tall screens; leaves room
      // for the on-screen keyboard, which is anchored just under the card.
      paddingTop: '12vh',
      boxSizing: 'border-box',
      zIndex: 200
    }
  }, /*#__PURE__*/_react.default.createElement(EmailCard, {
    style: {
      marginRight: 0,
      width: 480,
      padding: '24px 0',
      transform: 'scale(1.35)',
      transformOrigin: 'center',
      background: cell.user_info_bar_color || undefined
    },
    ref: emailCardRef
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.title',
    defaultMessage: 'Entrez vos informations'
  })), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.firstname',
    defaultMessage: 'Prénom'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'firstname' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('firstname');
      setKeyboardVisible(true);
    }
  }, userFirstName || ''), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.surname',
    defaultMessage: 'Nom'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'surname' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('surname');
      setKeyboardVisible(true);
    }
  }, userSurname || ''), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.birthdate',
    defaultMessage: 'Date de naissance'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'birthdate' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('birthdate');
      setKeyboardVisible(true);
    }
  }, userBirthdate || 'JJ-MM-AAAA'), /*#__PURE__*/_react.default.createElement(SendButton, {
    style: {
      background: cell.button_retake_background_color
    },
    onClick: function onClick() {
      setKeyboardVisible(false);
      setActiveInfoField(null);
      setStep('camera');
    },
    disabled: !userFirstName || !userSurname || !userBirthdate
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.continue',
    defaultMessage: 'Continuer'
  }))), keyboardVisible && activeInfoField && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: activeInfoField,
    setVisible: setKeyboardVisible,
    project: project,
    input: activeInfoField === 'firstname' ? userFirstName : activeInfoField === 'surname' ? userSurname : userBirthdate,
    setInput: activeInfoField === 'firstname' ? setUserFirstName : activeInfoField === 'surname' ? setUserSurname : setBirthdateMasked,
    anchorRef: emailCardRef
  })), (step === 'camera' || step === 'countdown' || step === 'scene') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CameraContainer, {
    className: "camera-container",
    ref: cameraContainerRef,
    cameraReady: hasCamera,
    square: isSquare,
    loaderBg: cell.loader_background_color
  }, /*#__PURE__*/_react.default.createElement(Camera, {
    square: isSquare,
    ref: cameraBoxRef
  }, !hasCamera && /*#__PURE__*/_react.default.createElement(Spinner, {
    color: cell.loader_spinner_color
  }), /*#__PURE__*/_react.default.createElement(VideoPreview, {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    mirror: mirror,
    square: isSquare,
    style: {
      display: hasCamera ? 'block' : 'none',
      // <--- invisible tant que pas prêt
      // Hidden visually: the PreviewCanvas shows the feed now. The video stays in the
      // DOM and playing (opacity, not display:none) so it remains a valid capture source.
      opacity: 0
    }
    // style={{ display: isProcessing && frozenFrame ? 'none' : 'block' }}
  }), /*#__PURE__*/_react.default.createElement(PreviewCanvas, {
    ref: displayCanvasRef,
    mirror: false,
    style: {
      display: hasCamera ? 'block' : 'none'
    }
  }), hasCamera && cell.collect_user_info && (userFirstName || userSurname || userBirthdate) && /*#__PURE__*/_react.default.createElement(UserInfoOverlay, {
    boxH: cameraBoxH,
    sizeScale: cell.user_info_text_size || 1,
    posPct: (cell.user_info_text_position != null ? cell.user_info_text_position : 12) / 100,
    hPosPct: (cell.user_info_text_h_position != null ? cell.user_info_text_h_position : 50) / 100,
    color: cell.user_info_text_color,
    font: font,
    firstName: userFirstName,
    surname: userSurname,
    birthdate: userBirthdate
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, step === 'countdown' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > photoTimer ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '20%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 16000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(AnimatedArrows, {
    cell: cell,
    font: font,
    intl: intl,
    textDatas: textDatas
  }), /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.text_color
    }
  }, (0, _utils.i18nData)(cell, 'look_text', intl, defaultLanguage) || textDatas.look))) : /*#__PURE__*/
  // Countdown numbers: descending (3,2,1) or ascending (1,2,3) per admin config.
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownNumber, null, countUp ? photoTimer - countdown + 1 : countdown)))) :
  // Dès que countdown = 0, on affiche le processing
  isProcessing && /*#__PURE__*/_react.default.createElement(ProgressBarContainer, null, /*#__PURE__*/_react.default.createElement(ProgressText, null, processingProgress < 50 ? (0, _utils.i18nData)(cell, 'preparing_photo_text', intl, defaultLanguage) || textDatas.preparingPhoto || "Preparing photo..." : (0, _utils.i18nData)(cell, 'almost_there_text', intl, defaultLanguage) || textDatas.almostThere || "Almost there..."), /*#__PURE__*/_react.default.createElement(ProgressBarWrapper, null, /*#__PURE__*/_react.default.createElement(ProgressBarFill, {
    progress: processingProgress
  }))))))),
  /* Only on the live camera step — NOT during the scene picker (which renders over the
     kept-alive camera) or the countdown. */
  step === 'camera' && /*#__PURE__*/_react.default.createElement(ControlBar, null, /*#__PURE__*/_react.default.createElement(CameraButton, {
    onClick: handleTakePhoto
  }, /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.text_color
    }
  }, "  ", (0, _utils.i18nData)(cell, 'button_take_text', intl, defaultLanguage) || textDatas.buttonTake)))), step === 'share' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Preview, {
    step: step,
    style: {
      color: cell.text_color
    }
  }, /*#__PURE__*/_react.default.createElement(PreviewWrapper2, {
    id: "preview-wrapper",
    square: isSquare
  }, capturedPreview && /*#__PURE__*/_react.default.createElement("div", {
    id: "preview-wrapper",
    ref: sharePreviewRef,
    style: {
      position: 'relative',
      width: '100%',
      // Square mode: a 1:1 box (height derived from width) so the square preview shows fully.
      height: isSquare ? 'auto' : '100%',
      aspectRatio: isSquare ? '1 / 1' : undefined,
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      outline: 'none',
      // (Kept for layout parity; the user-info overlay now sizes off measured box height,
      // not cqw, so this no longer drives the text size.)
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: capturedPreview,
    alt: "Preview avec rotation",
    crossOrigin: "anonymous",
    style: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }), cell.collect_user_info && (userFirstName || userSurname || userBirthdate) && /*#__PURE__*/_react.default.createElement(UserInfoOverlay, {
    boxH: shareBoxH,
    sizeScale: cell.user_info_text_size || 1,
    posPct: (cell.user_info_text_position != null ? cell.user_info_text_position : 12) / 100,
    hPosPct: (cell.user_info_text_h_position != null ? cell.user_info_text_h_position : 50) / 100,
    color: cell.user_info_text_color,
    font: font,
    firstName: userFirstName,
    surname: userSurname,
    birthdate: userBirthdate
  })))), /*#__PURE__*/_react.default.createElement(ShareOptionsContainer, {
    square: isSquare
  }, cell.email && /*#__PURE__*/_react.default.createElement(EmailCard, {
    ref: emailCardRef
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, (0, _utils.i18nData)(cell, 'send_by_email_text', intl, defaultLanguage) || textDatas.sendByEmail), /*#__PURE__*/_react.default.createElement(EmailInput, {
    onClick: function onClick() {
      setKeyboardVisible(true);
    }
  }, email || (0, _utils.i18nData)(cell, 'email_placeholder_text', intl, defaultLanguage) || textDatas.emailPlaceholder || 'EMAIL'), /*#__PURE__*/_react.default.createElement(SendButton, {
    style: {
      background: cell.button_retake_background_color
    },
    onClick: function onClick(e) {
      if (isSending) return;
      e.preventDefault();
      e.stopPropagation();
      handleShare(e);
    },
    disabled: !email || !consent || isSending
  }, (0, _utils.i18nData)(cell, 'send_text', intl, defaultLanguage) || textDatas.send), isSended && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'green',
      fontSize: '0.8rem',
      marginTop: '0.5rem'
    }
  }, (0, _utils.i18nData)(cell, 'sent_text', intl, defaultLanguage) || textDatas.sent), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      marginTop: '0.5rem',
      width: '90%'
    }
  }, /*#__PURE__*/_react.default.createElement(ShareCheckbox, {
    style: {
      fontFamily: font,
      fontSize: '0.5rem'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: consent,
    onChange: function onChange(e) {
      return setConsent(e.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font
    }
  }, (0, _utils.i18nData)(cell, 'conditions1_text', intl, defaultLanguage) || textDatas.conditions)))), showQRCode && cell.qr_code && /*#__PURE__*/_react.default.createElement(QRCodeCard, {
    style: {
      background: cell.qr_card_background_color || 'rgba(122, 103, 66, 0.2)'
    }
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, (0, _utils.i18nData)(cell, 'button_download_text', intl, defaultLanguage) || textDatas.buttonDownload), /*#__PURE__*/_react.default.createElement(QRCodeDisplay, {
    ref: qrBoxRef
  }, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: qrSize,
    bgColor: "transparent",
    fgColor: cell.qr_code_color || '#000000'
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '50%',
      height: '50%',
      border: '4px solid rgba(122, 103, 66, 0.3)',
      borderTop: '4px solid #7A6742',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }
  }), /*#__PURE__*/_react.default.createElement("style", null, "\n                        @keyframes spin {\n                          0% { transform: rotate(0deg); }\n                          100% { transform: rotate(360deg); }\n                        }\n                      ")))), showPrint && cell.print && /*#__PURE__*/_react.default.createElement(PrintCard, {
    style: {
      background: cell.button_print_background_color || cell.button_retake_background_color
    },
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var isPanini, toPrint, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!(!capturedImage || printed)) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            // Panini (portrait only): print 4 copies in a 2x2 grid; otherwise the single photo.
            isPanini = paniniPrint && !isSquare;
            toPrint = capturedImage;
            if (!isPanini) {
              _context5.n = 5;
              break;
            }
            _context5.p = 2;
            _context5.n = 3;
            return buildPaniniImage(capturedImage);
          case 3:
            toPrint = _context5.v;
            _context5.n = 5;
            break;
          case 4:
            _context5.p = 4;
            _t4 = _context5.v;
            console.error('Panini composite failed, printing single photo:', _t4);
          case 5:
            // Pass isPanini so Electron uses the true-centered 6×4 page (no fudge) for cutting.
            printImageData(toPrint, isPanini);
            setPrintButtonText(textDatas.printed);
          case 6:
            return _context5.a(2);
        }
      }, _callee5, null, [[2, 4]]);
    })),
    disabled: printed
  }, /*#__PURE__*/_react.default.createElement(PrintIconContainer, null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 17.9827C4.44655 17.9359 3.51998 17.7626 2.87868 17.1213C2 16.2426 2 14.8284 2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H16C18.8284 6 20.2426 6 21.1213 6.87868C22 7.75736 22 9.17157 22 12C22 14.8284 22 16.2426 21.1213 17.1213C20.48 17.7626 19.5535 17.9359 18 17.9827",
    stroke: "white",
    "stroke-width": "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 10H6",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 14L5 14",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.1213 2.87868L16.591 3.40901V3.40901L17.1213 2.87868ZM6.87868 2.87868L7.40901 3.40901V3.40901L6.87868 2.87868ZM6.87868 21.1213L7.40901 20.591H7.40901L6.87868 21.1213ZM18.75 14C18.75 13.5858 18.4142 13.25 18 13.25C17.5858 13.25 17.25 13.5858 17.25 14H18.75ZM6.75 14C6.75 13.5858 6.41421 13.25 6 13.25C5.58579 13.25 5.25 13.5858 5.25 14H6.75ZM17.25 16C17.25 17.4354 17.2484 18.4365 17.1469 19.1919C17.0482 19.9257 16.8678 20.3142 16.591 20.591L17.6517 21.6517C18.2536 21.0497 18.5125 20.2919 18.6335 19.3918C18.7516 18.5132 18.75 17.393 18.75 16H17.25ZM12 22.75C13.393 22.75 14.5132 22.7516 15.3918 22.6335C16.2919 22.5125 17.0497 22.2536 17.6517 21.6517L16.591 20.591C16.3142 20.8678 15.9257 21.0482 15.1919 21.1469C14.4365 21.2484 13.4354 21.25 12 21.25V22.75ZM12 2.75C13.4354 2.75 14.4365 2.75159 15.1919 2.85315C15.9257 2.9518 16.3142 3.13225 16.591 3.40901L17.6517 2.34835C17.0497 1.74643 16.2919 1.48754 15.3918 1.36652C14.5132 1.24841 13.393 1.25 12 1.25V2.75ZM12 1.25C10.607 1.25 9.48678 1.24841 8.60825 1.36652C7.70814 1.48754 6.95027 1.74643 6.34835 2.34835L7.40901 3.40901C7.68577 3.13225 8.07434 2.9518 8.80812 2.85315C9.56347 2.75159 10.5646 2.75 12 2.75V1.25ZM5.25 16C5.25 17.393 5.24841 18.5132 5.36652 19.3918C5.48754 20.2919 5.74643 21.0497 6.34835 21.6517L7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16H5.25ZM12 21.25C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591L6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.48678 22.7516 10.607 22.75 12 22.75V21.25ZM18.7323 5.97741C18.6859 4.43521 18.5237 3.22037 17.6517 2.34835L16.591 3.40901C17.0016 3.8196 17.1859 4.4579 17.233 6.02259L18.7323 5.97741ZM6.76698 6.02259C6.81413 4.4579 6.99842 3.8196 7.40901 3.40901L6.34835 2.34835C5.47633 3.22037 5.31413 4.43521 5.26766 5.97741L6.76698 6.02259ZM18.75 16V14H17.25V16H18.75ZM6.75 16V14H5.25V16H6.75Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17",
    cy: "10",
    r: "1",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 16.5H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 19H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })))), /*#__PURE__*/_react.default.createElement(PrintButton, null, printed ? (0, _utils.i18nData)(cell, 'printed_text', intl, defaultLanguage) || textDatas.printed || 'PRINTED' : (0, _utils.i18nData)(cell, 'print_text', intl, defaultLanguage) || textDatas.print || 'PRINT'))), /*#__PURE__*/_react.default.createElement(ButtonGroup, {
    square: isSquare
  }, /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    style: {
      background: cell.button_retake_background_color,
      color: cell.button_retake_text_color,
      border: "0.3em solid ".concat(cell.button_retake_border_color || '#FFFFFF')
    },
    onClick: handleRetake
  }, (0, _utils.i18nData)(cell, 'button_retake_text', intl, defaultLanguage) || textDatas.buttonRetake)), keyboardVisible && cell.email && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: 'Email',
    setVisible: setKeyboardVisible,
    project: project,
    input: email,
    setInput: setEmail,
    anchorRef: emailCardRef
  })), /*#__PURE__*/_react.default.createElement("canvas", {
    ref: previewCanvasRef,
    width: OUTPUT_WIDTH,
    height: OUTPUT_HEIGHT,
    style: {
      display: 'none',
      width: "".concat(OUTPUT_WIDTH, "px"),
      height: "".concat(OUTPUT_HEIGHT, "px")
    }
  }))), step === 'camera' && scenes.length >= 2 && typeof document !== 'undefined' && /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement(ChangeBgBar, {
    style: {
      top: "".concat(cell.change_bg_button_position != null ? cell.change_bg_button_position : 8, "%"),
      fontFamily: font,
      '--text-scale': cell.text_size || 1
    }
  }, /*#__PURE__*/_react.default.createElement(ChangeBgButton, {
    onClick: function onClick() {
      return setStep('scene');
    }
  }, textDatas.changeBackground || (0, _utils.i18nData)(cell, 'change_background_text', intl, defaultLanguage) || 'Change background')), document.body));
}
function AnimatedArrows(_ref72) {
  var cell = _ref72.cell;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "80",
    viewBox: "0 0 24 48"
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n            .moveUp {\n              animation: moveUp 0.8s ease-in-out infinite alternate;\n              transform-origin: 50% 50%;\n              transform-box: fill-box;\n            }\n\n            @keyframes moveUp {\n              0% { transform: translateY(0); }\n              100% { transform: translateY(-6px); }\n            }\n          "), /*#__PURE__*/_react.default.createElement("g", {
    className: "moveUp"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 10 12 3 19 10",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 20 12 13 19 20",
    fill: "none",
    stroke: "#bbbbbb",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 30 12 23 19 30",
    fill: "none",
    stroke: "#333333",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}